import clsx from "clsx";
import React from "react";
import * as styles from "./HamburgerButton.module.scss";

type HamburgeButtonProps = {
  onToggleMenu: () => void;
  isOpen: boolean;
  className?: string;
};

const HamburgeButton: React.FC<
  React.PropsWithChildren<HamburgeButtonProps>
> = ({ isOpen, onToggleMenu, className }) => {
  const label = isOpen ? "Close secondary menu" : "Open secondary menu";

  return (
    <React.Fragment>
      <button
        className={clsx(styles.menuButton, className, {
          [styles.menuButtonOpened]: isOpen
        })}
        aria-controls="ssc-secondary-menu-content"
        aria-expanded={isOpen}
        aria-label={label}
        onClick={onToggleMenu}
      >
        <span className={styles.menuIcon}>
          <span className={styles.navicon} aria-hidden="true"></span>
        </span>
      </button>
    </React.Fragment>
  );
};

export default HamburgeButton;
